import React, { useState, useEffect, useContext } from 'react';
import {Route, Routes} from "react-router-dom";

import Ee_Home from './ee/home.js';
import Ee_Prs from './ee/prs.js';
import Ee_Dep from './ee/dep.js';
import Ee_Sal from './ee/sal.js';
import {withRouter} from "../lib/react/withRouter";
import sso from "../sso";

function pg_home() {

    var html =
    <div className="web-content">
      Hem
    </div>
    ;
    return html;
}

class Ta_Ee extends React.Component {
    //var sdo = useContext(SDO);
  constructor(props, context) {
    super(props);

    this.webStore = props.store;
    this.state = { pgid: 11, deps: [] };
      var po = {};
      po.tot = { "fid": "f06", "url": "/ta/ee/tot", "name": "Personal", "active": false };
      po.avd = { "fid": "f06", "url": "/ta/ee/avd", "name": "Avdelningsvis", "active": false };
      po.day = { "fid": "f06", "url": "/ta/ee/day", "name": "Lönehantering", "active": false };
      this.state.po = po;
      this.state.pa = [];
      this.state.pa = Object.values(po);
  }
    fknGo(row) {
        sso.seo.sfkn = row;
        this.props.navigate(row.url);
    }
    br_css(row) {
        var css = {};
        if(sso.seo.sfkn && (row.url == sso.seo.sfkn.url)) css.color = "#080";
        //var brc = false;
        //if(row.url == sbo.state.url) brc = true;
        return css;
    }

  render() {
      //var path = window.location.pathname;
      //var op = path.split("/").pop();

    return (
        <div className="web-app">
            { this.props.store.cfg.bread ?
                <div className="web-bread">
                    <div className="breadcrumb">
                        { this.state.pa.map((row, key) =>
                            <div key={key} className="breadcrumb-item" style={this.br_css(row)} onClick={() => this.fknGo(row)}>{row.name}</div>
                        )}
                        <div className="flex"></div>
                        <div className="cdigreen">{ sso.seo.sfkn ? sso.seo.sfkn.name : null }</div>
                    </div>
                </div>
                : null }
        <Routes>
          <Route path="/xx" component={pg_home} />
            <Route path="prs" element={ <Ee_Prs store={this.webStore} />} />
            <Route path="dep" element={ <Ee_Dep store={this.webStore} />} />
            <Route path="sal" element={ <Ee_Sal store={this.webStore} />} />
            <Route path="*" element={ <Ee_Home store={this.webStore} />} />
        </Routes>
    </div>
  );
}
}
//Sys.contextType = ADOContext;

export default withRouter(Ta_Ee);
